export default "__VITE_ASSET__uQxdJb7O__"